import { DeploymentProfile } from 'types/GameHosting/deployment';

export const FETCH_DEPLOYMENT_PROFILE = 'FETCH_DEPLOYMENT_PROFILE';

export const FETCH_DEPLOYMENT_PROFILE_IS_PENDING = 'FETCH_DEPLOYMENT_PROFILE_IS_PENDING';

export const FETCH_DEPLOYMENT_PROFILE_IS_ERROR = 'FETCH_DEPLOYMENT_PROFILE_IS_ERROR';

export const FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES = 'FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES';

export const FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING = 'FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING';

export const FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR = 'FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR';

export const CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES';

export const CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING';

export const CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR';

export const EDIT_DEPLOYMENT_PROFILE_REGION_PROPERTIES = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES';

export const EDIT_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING';

export const EDIT_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR';

export const DELETE_DEPLOYMENT_PROFILE_REGION_PROPERTIES = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES';

export const DELETE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING';

export const DELETE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR = 'CREATE_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR';

export const FETCH_DEPLOYMENT_PROFILE_BY_ID = 'FETCH_DEPLOYMENT_PROFILE_BY_ID';

export const FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_PENDING = 'FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_PENDING';

export const FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_ERROR = 'FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_ERROR';

export const ADD_DEPLOYMENT_PROFILE_INLINE = 'ADD_DEPLOYMENT_PROFILE_INLINE';

export const CANCEL_EDITION_INLINE = 'CANCEL_EDITION_INLINE';

export const DEPLOYMENT_PROFILE_LOCAL_CHANGE = 'DEPLOYMENT_PROFILE_LOCAL_CHANGE';

export const DEPLOYMENT_PROFILE_CANCEL_LOCAL_CHANGES = 'DEPLOYMENT_PROFILE_CANCEL_LOCAL_CHANGES';

export const REGION_LOCAL_CHANGE = 'REGION_LOCAL_CHANGE';

export const CANCEL_REGION_LOCAL_CHANGE = 'CANCEL_REGION_LOCAL_CHANGE';

export const CREATE_DEPLOYMENT_PROFILE = 'CREATE_DEPLOYMENT_PROFILE';

export const CREATE_DEPLOYMENT_PROFILE_IS_PENDING = 'CREATE_DEPLOYMENT_PROFILE_IS_PENDING';

export const CREATE_DEPLOYMENT_PROFILE_IS_ERROR = 'CREATE_DEPLOYMENT_PROFILE_IS_ERROR';

export const UPDATE_DEPLOYMENT_PROFILE = 'UPDATE_DEPLOYMENT_PROFILE';

export const UPDATE_DEPLOYMENT_PROFILE_IS_PENDING = 'UPDATE_DEPLOYMENT_PROFILE_IS_PENDING';

export const UPDATE_DEPLOYMENT_PROFILE_IS_ERROR = 'UPDATE_DEPLOYMENT_PROFILE_IS_ERROR';

export const DELETE_DEPLOYMENT_PROFILE = 'DELETE_DEPLOYMENT_PROFILE';

export const DELETE_DEPLOYMENT_PROFILE_IS_PENDING = 'DELETE_DEPLOYMENT_PROFILE_IS_PENDING';

export const DELETE_DEPLOYMENT_PROFILE_IS_ERROR = 'DELETE_DEPLOYMENT_PROFILE_IS_ERROR';

export const CANCEL_DELETE_DEPLOYMENT_PROFILE = 'CANCEL_DELETE_DEPLOYMENT_PROFILE';

export const CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_PENDING = 'CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_PENDING';

export const CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_ERROR = 'CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_ERROR';

export const FETCH_REGION_BY_ID = 'FETCH_REGION_BY_ID';

export const FETCH_REGION_BY_ID_IS_PENDING = 'FETCH_REGION_BY_ID_IS_PENDING';

export const FETCH_REGION_BY_ID_IS_ERROR = 'FETCH_REGION_BY_ID_IS_ERROR';

export const CANCEL_REGION_INLINE_EDITION = 'CANCEL_REGION_INLINE_EDITION';

export const ADD_REGION = 'ADD_REGION';

export const ADD_REGION_IS_PENDING = 'ADD_REGION_IS_PENDING';

export const ADD_REGION_IS_ERROR = 'ADD_REGION_IS_ERROR';

export const UPDATE_REGION = 'UPDATE_REGION';

export const UPDATE_REGION_IS_PENDING = 'UPDATE_REGION_IS_PENDING';

export const UPDATE_REGION_IS_ERROR = 'UPDATE_REGION_IS_ERROR';

export const DELETE_REGION = 'DELETE_REGION';

export const DELETE_REGION_IS_PENDING = 'DELETE_REGION_IS_PENDING';

export const DELETE_REGION_IS_ERROR = 'DELETE_REGION_IS_ERROR';

export const CANCEL_DELETE_REGION = 'CANCEL_DELETE_REGION';

export const CANCEL_DELETE_REGION_IS_PENDING = 'CANCEL_DELETE_REGION_IS_PENDING';

export const CANCEL_DELETE_REGION_IS_ERROR = 'CANCEL_DELETE_REGION_IS_ERROR';

export const ADD_LOCATION_TO_REGION = 'ADD_LOCATION_TO_REGION';

export const CANCEL_LOCATION_TO_REGION = 'CANCEL_LOCATION_TO_REGION';

export const REMOVE_LOCATION_FROM_REGION = 'REMOVE_LOCATION_FROM_REGION';

export const ADD_CONTAINER = 'ADD_CONTAINER';

export const ADD_CONTAINER_LOCATION = 'ADD_CONTAINER_LOCATION';

export const SAVE_CONTAINER_LOCATION = 'SAVE_CONTAINER_LOCATION';

export const CANCEL_LOCATION_FROM_CONTAINER = 'CANCEL_LOCATION_FROM_CONTAINER';

export const DELETE_CONTAINER = 'DELETE_CONTAINER';

export const DELETE_CONTAINER_IS_PENDING = 'DELETE_CONTAINER_IS_PENDING';

export const DELETE_CONTAINER_IS_ERROR = 'DELETE_CONTAINER_IS_ERROR';

export const CANCEL_DELETE_CONTAINER = 'CANCEL_DELETE_CONTAINER';

export const CANCEL_DELETE_CONTAINER_IS_PENDING = 'CANCEL_DELETE_CONTAINER_IS_PENDING';

export const CANCEL_DELETE_CONTAINER_IS_ERROR = 'CANCEL_DELETE_CONTAINER_IS_ERROR';

export const DELETE_LOCATION = 'DELETE_LOCATION';

export const DELETE_LOCATION_IS_PENDING = 'DELETE_LOCATION_IS_PENDING';

export const DELETE_LOCATION_IS_ERROR = 'DELETE_LOCATION_IS_ERROR';

export const CANCEL_DELETE_LOCATION = 'CANCEL_DELETE_LOCATION';

export const CANCEL_DELETE_LOCATION_IS_PENDING = 'CANCEL_DELETE_LOCATION_IS_PENDING';

export const CANCEL_DELETE_LOCATION_IS_ERROR = 'CANCEL_DELETE_LOCATION_IS_ERROR';

export const SORT = 'SORT_DEPLOYMENT_PROFILES';

export const SORT_REGIONS = 'SORT_REGIONS';

export const CLEAN_ERROR = 'CLEAN_ERROR_DEPLOYMENT_PROFILE';

export type DeploymentProfileReducer = {
  depProfs: DeploymentProfile[];
  fetchIsCompleted: boolean;
  fetchIsPending: boolean;
  fetchIsError: null | boolean;
};

export type DeploymentProfileActions = { type: 'RESET_DEPLOYMENT_PROFILE_REDUCER' };
